// extracted by mini-css-extract-plugin
export var boldText = "_6c-4";
export var checkboxContainer = "_6c-6";
export var closeIcon = "_6c-i";
export var container = "_6c-0";
export var drawer = "_6c-8";
export var drawerContent = "_6c-9";
export var extraSmallText = "_6c-5";
export var fulfillmentGroupTable = "_6c-e";
export var largeText = "_6c-3";
export var loadingSpinnerContainer = "_6c-j";
export var mediumText = "_6c-2";
export var narrow = "_6c-f";
export var notificationLink = "_6c-l";
export var packageCheckIconContainer = "_6c-7";
export var slideoutHeaderActions = "_6c-g";
export var slideoutHeaderActionsShifted = "_6c-h";
export var slideoutHeaderContainer = "_6c-a";
export var slideoutModal = "_6c-c";
export var stickyHeaderWrapper = "_6c-b";
export var table = "_6c-k";
export var tableContainer = "_6c-d";
export var tertiaryText = "_6c-1";